import * as Sentry from "@sentry/vue";
import type { App } from "vue";

export function initSentry(app: App) {
    if (!import.meta.env.PROD) {
        return;
    }
    Sentry.init({
        app,
        dsn: "https://d71977a6d491d4c3953d249e755c404f@o4511645794041856.ingest.us.sentry.io/4511669597765632",
        sendDefaultPii: true,
        enableLogs: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration({ // 
            //     maskAllText: true,
            //     blockAllMedia: true,
            // }),
            Sentry.consoleLoggingIntegration({
                levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
            }),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
        release: import.meta.env.PUBLIC_SOURCE_COMMIT,
    });
}
